'use es6';

export const JS = 'JS';
export const MD = 'MD';
export const GRAPHQL = 'GRAPHQL';